module.exports = __webpack_public_path__ + "media/assets/images/logos/salesforce_logo-d1b6afff47becd73f364e886ac5d0723.png";